module.exports = __webpack_public_path__ + "3f0010f3039e442739b16129e5491410.svg";